// The Main Site Object
window.Site = {

    // Init Function
    liftoff : () => {

        Site.Menu.showHideOnClick() 
        Site.Suggestions.submit()
    },

    // Menu Functions
    Menu : {

        // We need a few items for the menu
        button : document.querySelector('[data-js="menu-button"]'),
        header : document.querySelector('[data-js="header"]'),

        // Open/Close On click
        showHideOnClick : () => {

            // The menu function
            function openAndCloseTheMenu () {
                document.documentElement.classList.toggle('menu-is-open')
                Site.Menu.button.innerHTML = (Site.Menu.button.innerHTML == 'MENU') ? 'CLOSE' : 'MENU'
            }

            document.body.addEventListener('click' , (event) => {
                if (event.target == document.body && document.documentElement.classList.contains('menu-is-open')) {
                    openAndCloseTheMenu()
                };
            })

            Site.Menu.button.addEventListener('click' , openAndCloseTheMenu)
        }

    },

    Suggestions : {

        button       : document.querySelector('#suggest-submit'),
        inputTitle   : document.querySelector('#suggest-title'),
        inputWebsite : document.querySelector('#suggest-website'),
        form         : document.querySelector('#suggest'),

        submit : () => {

            if (!Site.Suggestions.button) return;

            async function sendFormData () {
                
                // We need to store the new form data
                let formData = new FormData(Site.Suggestions.form);

                // Try sending out the data
                try {
                    
                    const response = await fetch(Site.Suggestions.form.action, {
                        method : "POST",
                        body   : formData,
                    });
                    
                    await response.json();

                    // If we got a positive response
                    if (response.status) {
                        document.body.classList.add('SUCCESS')
                        Site.Suggestions.inputTitle.value   = ""
                        Site.Suggestions.inputWebsite.value = ""

                        setTimeout(function(){
                            document.body.classList.remove('SUCCESS')
                        } , 1000)

                    } else {
                        document.body.classList.add('ERROR')
                    }

                } catch (e) {
                    console.error(e);
                }

            }

            Site.Suggestions.button.addEventListener('click' , (event) => {
                // Prevent the natural form submission
                event.preventDefault()
                sendFormData();


            })
        }

    }

}

// Launch The Script
Site.liftoff()